{
  "version": 1,
  "asset_id": "85244b74-7c12-404b-8aa0-9035ce5d6ead",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/85244b74-7c12-404b-8aa0-9035ce5d6ead/loc-houston-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/85244b74-7c12-404b-8aa0-9035ce5d6ead/loc-houston-640.webp",
  "original_filename": "loc-houston-640.webp",
  "size": 26018,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:27Z"
}
